import { useEffect, useState, useCallback } from "react";
import { adminApi } from "../../api";
import PrecarioHeaderForm from "./PrecarioHeaderForm";
import PrecarioItemsTable from "./PrecarioItemsTable";
import PrecarioDescontosTable from "./PrecarioDescontosTable";

export default function PrecarioEditor({ idPrecario, onChanged, onError, onInfo, eur }) {
  const [precario, setPrecario] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const r = await adminApi.precarioGet(idPrecario);
      setPrecario(r.item);
    } catch (e) { onError?.(e.message); }
    finally { setLoading(false); }
  }, [idPrecario, onError]);

  useEffect(() => { reload(); }, [reload]);

  if (loading) return <p className="text-sm text-[#6B7280]" data-testid="precario-editor-loading">A carregar editor...</p>;
  if (!precario) return null;

  return (
    <div className="space-y-5" data-testid="precario-editor">
      <PrecarioHeaderForm
        precario={precario}
        onSaved={async () => { await reload(); onChanged?.(); onInfo?.("Cabeçalho atualizado."); }}
        onError={onError}
      />
      <PrecarioItemsTable
        idPrecario={idPrecario}
        items={precario.Items || []}
        ivaPct={Number(precario.IVA_Pct || 23)}
        onChanged={async () => { await reload(); onChanged?.(); onInfo?.("Items atualizados."); }}
        onError={onError}
        eur={eur}
      />
      <PrecarioDescontosTable
        idPrecario={idPrecario}
        descontos={precario.Descontos || []}
        onChanged={async () => { await reload(); onChanged?.(); onInfo?.("Descontos atualizados."); }}
        onError={onError}
      />
    </div>
  );
}
